// extracted by css-extract-rspack-plugin
export default {"preferenceSection":"src-modules-desktop-components-PreferencesWindow-components-PreferenceMultiSelectField-PreferenceMultiSelectField-module__preferenceSection-dvz_I4","fieldHeader":"src-modules-desktop-components-PreferencesWindow-components-PreferenceMultiSelectField-PreferenceMultiSelectField-module__fieldHeader-C2KggI"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"preferenceSection\":\"src-modules-desktop-components-PreferencesWindow-components-PreferenceMultiSelectField-PreferenceMultiSelectField-module__preferenceSection-dvz_I4\",\"fieldHeader\":\"src-modules-desktop-components-PreferencesWindow-components-PreferenceMultiSelectField-PreferenceMultiSelectField-module__fieldHeader-C2KggI\"}";
        // 1793872695727
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  